import React from 'react';
import { styled } from 'styletron-react';

interface VersionTagProps extends React.HTMLAttributes<HTMLDivElement> {
  pipelineId: string;
  pipelineDate: string;
}

const VersionTagWrapper = styled('div', {
  fontSize: '10px',
  color: 'rgb(255, 255, 255)',
  cursor: 'default'
});

const VersionTag: React.FC<VersionTagProps> = (props) => {
  const { pipelineId, pipelineDate, style, className } = props;

  return (
    <VersionTagWrapper data-testid={'version-tag'} className={className} style={style}>
      <span data-testid="pipeline-id">{pipelineId}</span> started at{' '}
      <span data-testid="pipeline-date">{pipelineDate}</span>
    </VersionTagWrapper>
  );
};

export default VersionTag;
